import React, { memo, useContext } from 'react';
import './css/HomePage0.css';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { isValidObject, isValidString } from '../../../catalog/Validity';
import { createHomePageDescriptionTag } from '../../website/uiElements/helmet/MetaTags';
import { websiteStyles } from '../../../catalog/TeamInfo';

const HomePage0 = () => {
    const { globalState } = useContext(context);

    return (
        <div className="homepage0-container x-center">
            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo4) ? (
                <img src={globalState.logo.logo4} className="icon" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
            ) : null}
            {isValidString(createHomePageDescriptionTag(globalState)) ? (
                <p className="text font-size-xl m-t-40px p-l-20px p-r-20px font-spacing-wider">{createHomePageDescriptionTag(globalState)}</p>
            ) : null}
            <Spinner1 marginTop={50} color={websiteStyles.primaryColor} />
        </div>
    );
};

export default memo(HomePage0);
